import * as React from "react";
import { exportZoneFile } from "./utils/zoneFileUtils";
import { Button, notification } from "antd";
import { DomainDryRunConfigItem } from "./domainDryRunConfigItem";
import { DomainDryRunConfig as IDomainDryRunConfig } from "../../../schema/types/domain/input";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { cloneDeep } from "lodash";

interface Props {
  configs?: IDomainDryRunConfig[];
  label: "DNS Config" | "Ownership Config";
}
export const DomainDryRunConfig: React.FC<Props> = ({ label, configs: _configs = [] }) => {
  const configs = cloneDeep(_configs);

  const org = useAppSelector(selectOrg);

  const mode = useCpFormValue("meta.mode");
  const gvcAlias = useCpFormValue("gvc.item.alias") || "";
  const basicDomain = useCpFormValue("basic.name");
  const advancedDomain = useCpFormValue("advanced.name");
  const domain = React.useMemo(() => {
    return mode === "basic" ? basicDomain : advancedDomain;
  }, [mode, basicDomain, advancedDomain]);

  if (!configs || configs.length < 1) {
    return null;
  }

  function handleDownload(content: string): void {
    const a: HTMLAnchorElement = document.createElement("a");
    a.style.display = "none";
    a.classList.add("cpln-temp-a");
    a.download = `cpln-${domain}-dns-config.txt`;
    try {
      const file = new Blob([content], {
        type: `text/plain`,
      });
      a.href = URL.createObjectURL(file);
      a.click();
    } catch (e) {
      notification.error({ message: `Unable to download item, error: ${e.message}` });
    }
  }

  function handleExportDNSZoneFile() {
    const val = exportZoneFile(
      configs.map((c) => ({
        host: c.host,
        type: c.type as any,
        value: c.value,
        ttl: c.ttl,
      })),
    );
    handleDownload(val);
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="font-semibold">{label}</div>
        <Button type={"default"} size="small" htmlType={"button"} onClick={handleExportDNSZoneFile}>
          Export Zone File
        </Button>
      </div>
      <div className="mt-2 table-labels px-4 py-1 border grid grid-cols-8">
        <div className="col-span-1">Type</div>
        <div className="col-span-1">TTL</div>
        <div className="col-span-3">Host</div>
        <div className="col-span-3">Value</div>
      </div>
      {configs
        .filter((c) => {
          if (mode === "basic" && label.includes("Ownership") && c.value !== org) {
            return false;
          }
          return true;
        })
        .map((c) => {
          if (c.value.includes("<gvcAlias>") && gvcAlias) {
            c.value = c.value.replace("<gvcAlias>", gvcAlias);
          }
          return c;
        })
        .map((c) => (
          <div key={c.host + c.value} className="px-4 py-1 border border-t-0 grid grid-cols-8 dryRunConfig">
            <DomainDryRunConfigItem small value={c.type} />
            <DomainDryRunConfigItem small value={String(c.ttl)} />
            <DomainDryRunConfigItem value={c.host} />
            <DomainDryRunConfigItem value={c.value} />
          </div>
        ))}
    </>
  );
};
